import { createRouter, createWebHistory } from "vue-router";
import LoginView from "@/views/LoginView.vue";
import LandingPageView from "@/views/LandingPageView.vue";
import AdminMainView from "@/views/AdminMainView.vue";
import CheckGoogleAuth from "@/components/CheckGoogleAuth.vue";
import MainPage from "../views/MainView.vue";
import HomePage from "../views/HomeView.vue";
import StudioPage from "../views/StudioView.vue";
import UploadVidio from "../views/UploadingVideo.vue";
import WatchVidio from "../views/WatchVidio.vue";
import WatchVidioAdmin from "@/views/WatchVidioAdmin.vue";
import PaymentList from "@/views/PaymentList.vue";
import CreateOrganization from "@/views/CreateOrganization.vue";
import BookView from "@/views/BookView.vue";

const routes = [
  {
    path: "/login",
    name: "LoginView",
    component: LoginView,
    meta: {
      requiresAuth: false,
      redirectIfAuth: true,
    },
  },
  {
    path: "/",
    name: "Login",
    component: LoginView,
    meta: {
      requiresAuth: false,
      redirectIfAuth: true,
    },
  },
  {
    path: "/login/oauth2/code/google",
    name: "CheckGoogleAuth",
    component: CheckGoogleAuth,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/books",
    name: "BookView",
    component: BookView,
    meta: {
      requiresAuth: false,
      redirectIfAuth: true,
    },
  },
  {
    path: "/main",
    component: MainPage,
    children: [
      {
        component: HomePage,
        path: "home",
        name: "Home",
        meta: {
          requiresAuth: true,
          title: "Bosh sahifa",
        },
      },
      {
        component: LandingPageView,
        path: "landing",
        name: "Landing",
        meta: {
          requiresAuth: true,
        },
      },
      {
        component: AdminMainView,
        path: "payed",
        name: "Payed",
        meta: {
          requiresAuth: true,
          title: "To‘langanlar",
        },
      },
      {
        component: AdminMainView,
        path: "playlist",
        name: "Playlist",
        meta: {
          requiresAuth: true,
          title: "Ro‘yxatlar",
        },
      },
      {
        component: AdminMainView,
        path: "notifications",
        name: "Notifications",
        meta: {
          requiresAuth: true,
          title: "Bildirishnomalar",
        },
      },
      {
        component: AdminMainView,
        path: "history",
        name: "History",
        meta: {
          requiresAuth: true,
          title: "Tarix",
        },
      },
      {
        component: StudioPage,
        path: "studio",
        name: "Studio",
        meta: {
          requiresAuth: true,
          title: "Studio",
        },
      },
      {
        component: UploadVidio,
        path: "video-upload",
        name: "UploadVideo",
        meta: {
          requiresAuth: true,
          title: "Video yuklash",
        },
      },
      {
        component: WatchVidio,
        path: "watch-video",
        name: "WatchVideo",
        meta: {
          requiresAuth: false,
          title: "Video ko'rish",
        },
      },
      {
        component: WatchVidioAdmin,
        path: "watch-video-admin",
        name: "WatchVidioAdmin",
        meta: {
          requiresAuth: true,
        },
      },
      {
        component: PaymentList,
        path: "payments",
        name: "PaymentList",
        meta: {
          requiresAuth: true,
          title: "To'lovlar ro'yxati",
        },
      },
      {
        component: CreateOrganization,
        path: "create-organization",
        name: "CreateOrganization",
        meta: {
          requiresAuth: true,
          title: "Tashkilot yaratish",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  const defaultTitle = "Snappy";
  document.title = to.meta.title || defaultTitle;
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("accessToken");
  if (to.path === "/books") {
    console.log("Books sahifasiga kirish - token tekshiruvsiz");
    next();
    return;
  }
  if (to.matched.some((record) => record.meta.requiresAuth) && !token) {
    next({ name: "Login" });
    return;
  }
  if (to.matched.some((record) => record.meta.redirectIfAuth) && token) {
    next({ name: "Home" });
    return;
  }
  next();
});

export default router;
